import { Grid } from "@mui/material";
import SoftBox from "components/SoftBox";
import SoftDatePicker from "components/SoftDatePicker";
import SoftTypography from "components/SoftTypography";
import { useEffect } from "react";

function Datepicker({ title = "Τίτλος", xs = 12, md = 6, initialValue = new Date(), handler }) {
  return (
    <Grid item xs={xs} md={md}>
      <SoftBox display="flex" flexDirection="column" justifyContent="flex-end" height="100%">
        <SoftBox mb={1} ml={0.5} mt={3} lineHeight={0} display="inline-block">
          <SoftTypography component="label" variant="caption" fontWeight="bold">
            {title}
          </SoftTypography>
        </SoftBox>
        <SoftDatePicker value={initialValue} onChange={handler} size="large" />
      </SoftBox>
    </Grid>
  );
}

export default Datepicker;
